<template>
	<div class="login-container">
		<!-- 动态流体背景 (保留原有圆形光斑作为底层氛围) -->
		<div class="bg-shapes">
			<div class="shape shape-1"></div>
			<div class="shape shape-2"></div>
			<div class="shape shape-3"></div>
		</div>

		<!-- 新增：透明方块泡泡层 -->
		<div class="bubble-layer">
			<div class="square-bubble sb-1"></div>
			<div class="square-bubble sb-2"></div>
			<div class="square-bubble sb-3"></div>
			<div class="square-bubble sb-4"></div>
			<div class="square-bubble sb-5"></div>
		</div>

		<!-- 主卡片 -->
		<div class="main-card">

			<!-- 视图 1: 登录 (Login) -->
			<div v-if="currentView === 'login'" class="view-content">
				<div class="card-header">
					<div class="logo-box">
						<el-icon :size="32" color="#409EFF">
							<Platform />
						</el-icon>
					</div>
					<h2 class="title">欢迎登录</h2>
					<!-- <p class="subtitle">请使用您的账号访问系统</p> -->
				</div>

				<!-- 登录方式 Tabs -->
				<div class="login-tabs">
					<div class="tab-item" :class="{ active: loginMode === 'password' }" @click="loginMode = 'password'">
						账号登录
						<span class="tab-line" v-if="loginMode === 'password'"></span>
					</div>
					<div class="tab-item" :class="{ active: loginMode === 'qr' }" @click="loginMode = 'qr'">
						扫码登录
						<span class="tab-line" v-if="loginMode === 'qr'"></span>
					</div>
				</div>

				<!-- 账号密码表单 -->
				<div v-if="loginMode === 'password'" class="form-wrapper">
					<el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" @keyup.enter="handleLogin">
						<el-form-item prop="account">
							<el-input v-model="loginForm.account" :prefix-icon="User" placeholder="用户名/手机号" size="large"
								clearable />
						</el-form-item>
						<el-form-item prop="password">
							<el-input v-model="loginForm.password" type="password" :prefix-icon="Lock"
								placeholder="请输入密码" size="large" show-password />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" size="large" class="submit-btn" :loading="loading"
								@click="handleLogin">
								登 录
							</el-button>
						</el-form-item>
					</el-form>
				</div>

				<!-- 扫码登录区域 -->
				<div v-else class="qr-wrapper">
					<div class="qr-box">
						<!-- 模拟二维码 -->
						<div class="qr-code-mock">
							<el-icon :size="60" color="#e5e7eb">
								<QrCode />
							</el-icon>
							<div v-if="qrScanned" class="qr-success-mask">
								<el-icon :size="40" color="#10b981">
									<CircleCheckFilled />
								</el-icon>
								<p>扫描成功</p>
							</div>
						</div>
						<p class="qr-tip">请使用手机 App 扫描二维码</p>
						<p class="qr-subtip">刷新二维码</p>
					</div>
				</div>

				<!-- 底部链接 -->
				<div class="card-footer">
					<span class="link-text" @click="switchView('register')">注册账号</span>
					<span class="divider">|</span>
					<span class="link-text gray" @click="switchView('forgot')">忘记密码?</span>
				</div>
			</div>

			<!-- 视图 2: 注册 (Register) -->
			<div v-if="currentView === 'register'" class="view-content">
				<div class="card-header">
					<h2 class="title">创建新账号</h2>
					<p class="subtitle">填写以下信息完成注册</p>
				</div>

				<el-form ref="registerFormRef" :model="registerForm" :rules="registerRules" label-width="0">
					<el-form-item prop="phone">
						<el-input v-model="registerForm.phone" :prefix-icon="Iphone" placeholder="请输入手机号"
							size="large" />
					</el-form-item>
					<el-form-item prop="code">
						<div class="code-group">
							<el-input v-model="registerForm.code" :prefix-icon="Key" placeholder="验证码" size="large" />
							<el-button class="code-btn" size="large" :disabled="regCountdown > 0">
								{{ regCountdown > 0 ? `${regCountdown}s` : '获取验证码' }}
							</el-button>
						</div>
					</el-form-item>
					<el-form-item prop="password">
						<el-input v-model="registerForm.password" type="password" :prefix-icon="Lock" placeholder="设置密码"
							size="large" show-password />
					</el-form-item>
					<el-form-item prop="confirmPassword">
						<el-input v-model="registerForm.confirmPassword" type="password" :prefix-icon="Lock"
							placeholder="确认密码" size="large" show-password />
					</el-form-item>

					<el-form-item>
						<el-button type="primary" size="large" class="submit-btn" :loading="regLoading"
							@click="handleRegister">
							立即注册
						</el-button>
					</el-form-item>
				</el-form>

				<div class="card-footer center">
					<span class="link-text gray" @click="switchView('login')">已有账号? 去登录</span>
				</div>
			</div>

			<!-- 视图 3: 忘记密码 (Forgot Password) -->
			<div v-if="currentView === 'forgot'" class="view-content">
				<div class="card-header">
					<h2 class="title">重置密码</h2>
					<p class="subtitle">通过手机号验证身份</p>
				</div>

				<el-form ref="forgotFormRef" :model="forgotForm" :rules="forgotRules" label-width="0">
					<el-form-item prop="phone">
						<el-input v-model="forgotForm.phone" :prefix-icon="Iphone" placeholder="注册手机号" size="large" />
					</el-form-item>
					<el-form-item prop="code">
						<div class="code-group">
							<el-input v-model="forgotForm.code" :prefix-icon="Key" placeholder="验证码" size="large" />
							<el-button class="code-btn" size="large" :disabled="forgotCountdown > 0">
								{{ forgotCountdown > 0 ? `${forgotCountdown}s` : '获取验证码' }}
							</el-button>
						</div>
					</el-form-item>
					<el-form-item prop="newPassword">
						<el-input v-model="forgotForm.newPassword" type="password" :prefix-icon="Lock" placeholder="新密码"
							size="large" show-password />
					</el-form-item>

					<el-form-item>
						<el-button type="primary" size="large" class="submit-btn" :loading="forgotLoading"
							@click="handleResetPassword">
							确认重置
						</el-button>
					</el-form-item>
				</el-form>

				<div class="card-footer center">
					<span class="link-text gray" @click="switchView('login')">返回登录</span>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	// 解决 vue/multi-word-component-names
	export default {
		name: 'LoginPage'
	}
</script>

<script setup>
	import {
		ref,
		reactive
	} from 'vue'
	import {
		ElMessage
	} from 'element-plus'
	// 解决 no-unused-vars
	import {
		User,
		Lock,
		Iphone,
		Key,
		Platform,
		QrCode,
		CircleCheckFilled
	} from '@element-plus/icons-vue'
	import apiService from "../../util/apiService.js"
	// --- 视图控制 ---
	const currentView = ref('login') // 'login', 'register', 'forgot'
	const loginMode = ref('password') // 'password', 'qr'

	// --- 状态变量 ---
	const loading = ref(false)
	const regLoading = ref(false)
	const forgotLoading = ref(false)
	const qrScanned = ref(false)

	// 倒计时
	const regCountdown = ref(0)
	const forgotCountdown = ref(0)

	// --- 表单数据 ---
	const loginForm = reactive({
		account: '',
		password: '',
		mode: "password"
	})
	const registerForm = reactive({
		phone: '',
		code: '',
		password: '',
		confirmPassword: ''
	})
	const forgotForm = reactive({
		phone: '',
		code: '',
		newPassword: ''
	})

	// --- 表单引用 ---
	const loginFormRef = ref(null)
	const registerFormRef = ref(null)
	const forgotFormRef = ref(null)

	// --- 验证规则 ---
	const loginRules = {
		account: [{
			required: true,
			message: '请输入账号',
			trigger: 'blur'
		}],
		password: [{
			required: true,
			message: '请输入密码',
			trigger: 'blur'
		}]
	}

	const registerRules = {
		phone: [{
			required: true,
			pattern: /^1[3-9]\d{9}$/,
			message: '请输入正确的手机号',
			trigger: 'blur'
		}],
		code: [{
			required: true,
			message: '请输入验证码',
			trigger: 'blur'
		}],
		password: [{
			required: true,
			min: 6,
			message: '密码至少6位',
			trigger: 'blur'
		}],
		confirmPassword: [{
				required: true,
				message: '请确认密码',
				trigger: 'blur'
			},
			{
				validator: (rule, value, callback) => {
					if (value !== registerForm.password) {
						callback(new Error('两次输入密码不一致'))
					} else {
						callback()
					}
				},
				trigger: 'blur'
			}
		]
	}

	const forgotRules = {
		phone: [{
			required: true,
			message: '请输入手机号',
			trigger: 'blur'
		}],
		code: [{
			required: true,
			message: '请输入验证码',
			trigger: 'blur'
		}],
		newPassword: [{
			required: true,
			min: 6,
			message: '新密码至少6位',
			trigger: 'blur'
		}]
	}

	// --- 方法 ---

	// 切换视图
	const switchView = (view) => {
		currentView.value = view
		// 重置相关状态
		if (view === 'login') loginMode.value = 'password'
	}

	// 登录处理
	const handleLogin = async () => {
		if (!loginFormRef.value) return
		await loginFormRef.value.validate((valid) => {
			if (valid) {
				loading.value = true
				apiService.post({
						modules: "login",
						content: loginForm
					})
					.then((res) => {
						if (res.status) {
							localStorage.setItem( "Authorization",res.data.JwtToken);
							ElMessage.success('登录成功')
							setTimeout(() => {
								window.location.replace('/home')
							}, 200)
						}
					})
					.catch((err) => {
						ElMessage.error('登录失败'+err)
					})
					.finally(() => {
						loading.value = false
					});
				
			}
		})
	}

	// 注册处理
	const handleRegister = async () => {
		if (!registerFormRef.value) return
		await registerFormRef.value.validate((valid) => {
			if (valid) {
				regLoading.value = true
				setTimeout(() => {
					regLoading.value = false
					ElMessage.success('注册成功，请登录')
					switchView('login')
				}, 1500)
			}
		})
	}

	// 重置密码处理
	const handleResetPassword = async () => {
		if (!forgotFormRef.value) return
		await forgotFormRef.value.validate((valid) => {
			if (valid) {
				forgotLoading.value = true
				setTimeout(() => {
					forgotLoading.value = false
					ElMessage.success('密码重置成功')
					switchView('login')
				}, 1500)
			}
		})
	}

	// 模拟扫码状态变化
	setTimeout(() => {
		if (loginMode.value === 'qr') qrScanned.value = true
	}, 3000)
</script>

<style scoped>
	/* 容器 */
	.login-container {
		position: relative;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		display: flex;
		justify-content: flex-end;
		/* 修改：内容靠右对齐 */
		align-items: center;
		background-color: #f0f7ff;
		padding-right: 10%;
		/* 增加右侧间距，避免贴边 */
	}

	/* 背景动画 (底层模糊光斑) */
	.bg-shapes {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
	}

	.shape {
		position: absolute;
		border-radius: 50%;
		filter: blur(60px);
		opacity: 0.6;
		animation: floatShape 20s infinite ease-in-out;
	}

	.shape-1 {
		width: 400px;
		height: 400px;
		background: linear-gradient(135deg, #a5b4fc 0%, #818cf8 100%);
		top: -100px;
		left: -100px;
	}

	.shape-2 {
		width: 300px;
		height: 300px;
		background: linear-gradient(135deg, #67e8f9 0%, #22d3ee 100%);
		bottom: -50px;
		right: -50px;
		animation-direction: reverse;
	}

	.shape-3 {
		width: 200px;
		height: 200px;
		background: linear-gradient(135deg, #fbcfe8 0%, #f472b6 100%);
		top: 40%;
		left: 60%;
	}

	@keyframes floatShape {

		0%,
		100% {
			transform: translate(0, 0) scale(1);
		}

		33% {
			transform: translate(30px, -50px) scale(1.1);
		}

		66% {
			transform: translate(-20px, 20px) scale(0.9);
		}
	}

	/* 新增：透明方块泡泡层 */
	.bubble-layer {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		pointer-events: none;
	}

	.square-bubble {
		position: absolute;
		border: 1px solid rgba(255, 255, 255, 0.4);
		background: rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(2px);
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
		animation: floatBubble 15s infinite linear;
	}

	/* 定义不同大小和位置的方块 */
	.sb-1 {
		width: 60px;
		height: 60px;
		top: 15%;
		left: 10%;
		animation-duration: 20s;
		transform: rotate(15deg);
	}

	.sb-2 {
		width: 100px;
		height: 100px;
		top: 60%;
		left: 20%;
		animation-duration: 25s;
		animation-delay: -5s;
		transform: rotate(-10deg);
	}

	.sb-3 {
		width: 40px;
		height: 40px;
		top: 30%;
		left: 35%;
		animation-duration: 18s;
		animation-delay: -2s;
		border-color: rgba(64, 158, 255, 0.3);
	}

	.sb-4 {
		width: 80px;
		height: 80px;
		top: 75%;
		left: 5%;
		animation-duration: 22s;
		animation-delay: -8s;
		transform: rotate(45deg);
	}

	.sb-5 {
		width: 50px;
		height: 50px;
		top: 10%;
		left: 45%;
		animation-duration: 16s;
		animation-delay: -1s;
		background: rgba(255, 255, 255, 0.15);
	}

	@keyframes floatBubble {
		0% {
			transform: translateY(0) rotate(0deg);
			opacity: 0.8;
		}

		50% {
			transform: translateY(-20px) rotate(180deg);
			opacity: 0.4;
		}

		100% {
			transform: translateY(0) rotate(360deg);
			opacity: 0.8;
		}
	}

	/* 主卡片 */
	.main-card {
		position: relative;
		z-index: 1;
		width: 420px;
		min-height: 500px;
		padding: 40px;
		background: rgba(255, 255, 255, 0.9);
		/* 稍微增加一点透明度以融合背景 */
		backdrop-filter: blur(10px);
		border-radius: 24px;
		box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
		animation: fadeInUp 0.6s ease-out;
		display: flex;
		flex-direction: column;
		border: 1px solid rgba(255, 255, 255, 0.5);
		right: 10vw;
	}

	.view-content {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* 头部 */
	.card-header {
		text-align: center;
		margin-bottom: 30px;
	}

	.logo-box {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: 56px;
		height: 56px;
		background: #eff6ff;
		border-radius: 16px;
		margin-bottom: 16px;
		color: #409EFF;
	}

	.title {
		font-size: 24px;
		font-weight: 600;
		color: #1f2937;
		margin: 0 0 8px 0;
	}

	.subtitle {
		font-size: 14px;
		color: #9ca3af;
		margin: 0;
	}

	/* Tabs */
	.login-tabs {
		display: flex;
		justify-content: center;
		gap: 30px;
		margin-bottom: 25px;
		position: relative;
	}

	.login-tabs::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 1px;
		background: #f3f4f6;
	}

	.tab-item {
		position: relative;
		padding-bottom: 12px;
		cursor: pointer;
		font-size: 15px;
		color: #9ca3af;
		font-weight: 500;
		transition: all 0.3s;
	}

	.tab-item.active {
		color: #1f2937;
	}

	.tab-line {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 2px;
		background: #409EFF;
		border-radius: 2px;
		animation: slideIn 0.3s ease;
	}

	@keyframes slideIn {
		from {
			transform: scaleX(0);
		}

		to {
			transform: scaleX(1);
		}
	}

	/* 表单通用 */
	.form-wrapper {
		flex: 1;
	}

	:deep(.el-form-item) {
		margin-bottom: 20px;
	}

	:deep(.el-input__wrapper) {
		background-color: #f9fafb;
		box-shadow: 0 0 0 1px #e5e7eb inset;
		border-radius: 10px;
		padding: 10px 12px;
		transition: all 0.3s;
	}

	:deep(.el-input__wrapper.is-focus) {
		background-color: #fff;
		box-shadow: 0 0 0 1px #409EFF inset !important;
	}

	:deep(.el-input__inner) {
		color: #1f2937;
	}

	.submit-btn {
		width: 100%;
		margin-top: 10px;
		font-weight: 600;
		letter-spacing: 2px;
		height: 48px;
		font-size: 16px;
		background: linear-gradient(135deg, #409EFF 0%, #2563eb 100%);
		border: none;
		border-radius: 10px;
		box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
		transition: all 0.3s;
	}

	.submit-btn:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
	}

	/* 验证码组 */
	.code-group {
		display: flex;
		gap: 12px;
		width: 100%;
	}

	.code-btn {
		min-width: 120px;
		background: #eff6ff;
		border: 1px solid #bfdbfe;
		color: #2563eb;
		border-radius: 10px;
		font-weight: 500;
	}

	.code-btn:hover:not(:disabled) {
		background: #dbeafe;
	}

	/* 扫码区域 */
	.qr-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 20px 0;
	}

	.qr-box {
		text-align: center;
	}

	.qr-code-mock {
		width: 180px;
		height: 180px;
		background: #f9fafb;
		border: 1px solid #e5e7eb;
		border-radius: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto 15px;
		position: relative;
		overflow: hidden;
	}

	.qr-success-mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(255, 255, 255, 0.95);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		animation: fadeIn 0.3s;
	}

	.qr-tip {
		font-size: 14px;
		color: #6b7280;
		margin: 5px 0;
	}

	.qr-subtip {
		font-size: 12px;
		color: #9ca3af;
		cursor: pointer;
		text-decoration: underline;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	/* 底部链接 */
	.card-footer {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: auto;
		padding-top: 20px;
		font-size: 13px;
		gap: 12px;
	}

	.card-footer.center {
		justify-content: center;
	}

	.link-text {
		cursor: pointer;
		color: #6b7280;
		transition: color 0.2s;
	}

	.link-text:hover {
		color: #409EFF;
	}

	.link-text.gray:hover {
		color: #2563eb;
	}

	.divider {
		color: #e5e7eb;
	}

	/* 响应式 */
	@media (max-width: 768px) {
		.login-container {
			justify-content: center;
			/* 移动端居中 */
			padding-right: 0;
		}

		.main-card {
			width: 90%;
			padding: 30px 20px;
			min-height: auto;
		}

		.square-bubble {
			display: none;
		}

		/* 移动端隐藏复杂背景以提升性能 */
	}
</style>